import loading from "../../photos/Spinner-1.9s-137px.gif";
import React, {useEffect, useRef, useState} from "react";
import Icon from "../../components/atoms/Icon";
import {ClientListRepository} from "../../repository/AdminDashboard/Client-Repository";

const ValidateClientPasswordComponent = ({id}) => {

    const [passwordBtnLoading, setPasswordBtnLoading] = useState(false)
    const [timerCountdown, setTimerCountdown] = useState(59)
    const [passwordValue, setPasswordValue] = useState()
    const [isPasswordSend, setIsPasswordSend] = useState(false)
    const timerRef = useRef();

    const sendPassword = async () => {
        setPasswordBtnLoading(true)

        const response = await ClientListRepository.passwordClient(id);
        if (response.code !== 1) {
            console.log(">>ERROR PASSWORD CLIENT")
            return;
        }
        setPasswordBtnLoading(false)
        setTimerCountdown(59);
        setIsPasswordSend(true)
        setPasswordValue(response.pass)
    }
    function passwordBtnChild() {
        if (passwordBtnLoading && !isPasswordSend) {
            return <img className="w-7 h-7" src={loading} alt="Loading..." />;
        }

        if (isPasswordSend) {
            return timerCountdown > 0
                ? <span>00:{timerCountdown}</span>
                : <>ارسال دوباره رمز</>;
        }

        return <>ارسال رمز به شماره کاربر</>;
    }

    useEffect(() => {
        if (isPasswordSend && timerCountdown > 0) {
            timerRef.current = setTimeout(() => {
                setTimerCountdown(prev => prev - 1);
            }, 1000);
        } else {
            clearTimeout(timerRef.current);
        }

        return () => clearTimeout(timerRef.current);
    }, [isPasswordSend, timerCountdown]);
    return (
        <div className={"flex flex-col w-full"}>
            <label
                htmlFor="name"
                className="text-dark-blue-200 text-12 font-normal leading-5 mb-2.5">
                ارسال رمز احراز هویت (در صورت نیاز)
            </label>
            <div
                className="flex flex-row justify-between  bg-gray-chart-200 w-full px-3.5 gap-2.5 items-center rounded-sm  h-12.6">
                <div className="flex flex-row items-center gap-2.5">
                    <Icon iconName="password-check"/>
                    {passwordValue ? (
                        <span className="bg-gray-chart-200 text-dark-blue-200 text-14 py-3.5">
                        {passwordValue}
                      </span>) :
                        (<span className="bg-gray-chart-200  text-dark-blue-200 text-14 py-3.5">
                        هنوز رمزی ارسال نشده است.
                      </span>)}
                </div>

                <button
                    id={id}
                    onClick={sendPassword}
                    className="flex flex-row justify-center items-center w-28.5 font-normal text-12  text-dark-blue-200 leading-5 border-r-1 border-gray3 pr-2.5">

                    {passwordBtnChild()}


                </button>
            </div>
        </div>
    )
}
export default ValidateClientPasswordComponent